export function MyPinboardSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/my-pinboard.svg'"></ng-include>`
    }
}